// extracted by mini-css-extract-plugin
module.exports = {"heading":"discount-column_heading__1ddmk"};